export default "/images/687f81241317548d73752699b035578d.avif";